import i18n, { isSupported, setLanguage } from '../i18n';
import auth from '../services/authService';
import userService from '../services/userService';
import { getSetting, setSetting, settingKeys } from '../utils/settings';

/**
 * The account's language is the one the app follows, on every device. This device keeps a copy, so
 * the app starts in it straight away, offline too, and signed-out screens have one to show.
 */

/** Saves a language to the account, or marks it to try again at the next start. */
export async function saveAccountLanguage(language) {
  try {
    await userService.saveLanguage(language);
    setSetting(settingKeys.languageUnsaved, false);
  } catch (ex) {
    setSetting(settingKeys.languageUnsaved, true);
  }
}

/** Picked in Settings: switches the app, and saves it to the account when signed in. */
export async function changeLanguage(language) {
  await setLanguage(language);

  if (auth.getCurrentUser()) await saveAccountLanguage(i18n.language);
}

/**
 * At start, signed in: follows the account's language. A language picked here that never reached
 * the account is sent first instead, and so is this device's for an account that has none yet.
 */
export async function syncAccountLanguage(user = auth.getCurrentUser()) {
  if (!user?._id) return;

  if (getSetting(settingKeys.languageUnsaved)) {
    await saveAccountLanguage(i18n.language);
    return;
  }

  try {
    const { data } = await userService.getUser(user._id, { silent: true });

    if (!isSupported(data.language)) await saveAccountLanguage(i18n.language);
    else if (data.language !== i18n.language) await setLanguage(data.language);
  } catch (ex) {
    // Offline or unreachable: the copy kept here stands until next time
  }
}
